var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202.94301,
    height: 32,
    viewBox: "0 0 202.94301 32",
    fill: "none",
    id: "svg22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g863",
    transform: "scale(0.27633851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92.3,73.5 V 46.3 L 85.1,36.9 V 21.1 L 62,12.8 V 0 H 30.3 V 12.8 L 7.2,21.1 V 36.9 L 0,46.3 V 73.5 L 7.2,83.2 0,105.6 46.2,115.8 92.3,105.6 85.1,83.2 Z",
    fill: "#fff200",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.2,83.2 C 58.9578,83.2 69.3,72.8578 69.3,60.1 69.3,47.3422 58.9578,37 46.2,37 33.4422,37 23.1,47.3422 23.1,60.1 c 0,12.7578 10.3422,23.1 23.1,23.1 z",
    fill: "#000000",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 178.4,107.9 h -10 v -10.0001 -10 -10 -10 h -10 -10 v 10 10 10 10.0001 h -10 -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 v 10 10 10 10 h 10 10 v -10 -10 -10 -10 h 10 10 v 10 10 10 10 10 10 10 10 10 10.0001 z",
    fill: "#fff200",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 256.4,107.9 h -10 -10 -10 -10 -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 10 10 10 10 v 10 10 h -10 -10 -10 -10 v 10 10 h 10 10 10 10 v 10 10 h -10 -10 -10 -10 v 10 10 h 10 10 10 10 v 10 10.0001 z",
    fill: "#fff200",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 334.4,107.9 h -10 v -10.0001 -10 -10 -10 h -10 -10 v 10 10 10 10.0001 h -10 -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 10 10 10 10 v 10 10 10 10 10 10 10 10 10 10.0001 z m -20,-60.0001 h 10 v -10 -10 h -10 -10 v 10 10 z",
    fill: "#fff200",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 392.4,107.9 h -10 -10 -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 10 10 v 10 10 h 10 10 v 10 10 10 10 10 10 h -10 -10 v -10 -10 -10 -10 -10 -10 h -10 -10 v 10 10 10 10 10 10 h 10 10 v 10 10.0001 z",
    fill: "#fff200",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 490.4,107.9 h -10 -10 -10 -10 -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 v 10 10 10 10 10 10 10 10 h 10 10 10 10 v 10 10.0001 z",
    fill: "#fff200",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 568.4,107.9 h -10 v -10.0001 -10 -10 -10 h -10 -10 v 10 10 10 10.0001 h -10 -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 10 10 10 10 v 10 10 10 10 10 10 10 10 10 10.0001 z m -20,-60.0001 h 10 v -10 -10 h -10 -10 v 10 10 z",
    fill: "#fff200",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 646.4,107.9 h -10 v -10.0001 -10 -10 -10 -10 -10 h -10 -10 v 10 10 10 10 10 10.0001 h -10 -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 v 10 10 h 10 10 v -10 -10 h 10 10 v 10 10 10 10 10 10 10 10 10 10.0001 z",
    fill: "#fff200",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 684.4,107.9 h -10 v -10.0001 -10 -10 -10 -10 -10 -10 -10 -10 -10 h 10 10 10 10 10 10 v 10 10 10 10 10 10 h -10 -10 -10 -10 v 10 10 10 10.0001 z m 20,-60.0001 h 10 v -10 -10 h -10 -10 v 10 10 z",
    fill: "#fff200",
    id: "path20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.a560b2c3edd995150182dc71bc7834e1.svg";
export { ForwardRef as ReactComponent };